import React, { Component } from 'react'
import DialogWrapper from '../../../../components/DialogWrapper'
import { Button, Switch, Typography } from '@mui/material';
import ValidatedTextInput from '../../../../components/ValidatedTextInput';
import { ALERT_SEVERITY } from '../../../../components/AlertDisplay2';
import YesNoDialog from '../../../../components/YesNoDialog';
import LabeledSwitch from '../../../../components/LabeledSwitch';
import ValidTimeRangeSection from './Sections/ValidTimeRangeSection';
import DiscountConfigSection, { DISCOUNT_TYPES } from './Sections/DiscountConfigSection';
import CapConfigSection from './Sections/CapConfigSection';
import DeliveryConfigSection, { DELIVERY_CONFIG_TYPE } from './Sections/DeliveryConfigSection';
import { APIData } from '../../../../constants/APIAdresses';
import ShopSelectionSection, { SHOP_SELECTION_TYPES } from './Sections/ShopSelectionSection';
import { checkCodeAvailabilityForCreation, createPromoCode, editPromoCode, getShopInfoByIdList } from '../../../../APIHelper';
import EntitySelectionDialog from '../../../../components/EntitySelection/EntitySelectionDialog';
import DayPickerDialog from '../../../../components/DayPickerDialog';
import TimeConfigSection from './Sections/TimeConfigSection';
import PostalCodeConfigSection from './Sections/PostalCodeConfigSection';
import ProductConfigSection, { PRODUCT_RESTRICTION_SELECTION_TYPES, PRODUCT_SCOPE_TYPE } from './Sections/ProductConfigSection';
import { Box } from '@mui/system';
import CategoryConfigSection, { CATEGORY_RESTRICTION_SELECTION_TYPES, CATEGORY_SCOPE_TYPE } from './Sections/CategoryConfigSection';
import PaymentMethodConfigSection, { PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES, PAYMENT_METHOD_TYPE } from './Sections/PaymentMethodConfigSection';
import PromoCodeCombineRestrictionConfigSection from './Sections/PromoCodeCombineRestrictionConfigSection';
const DEFAULT_NOT_EDITABLE_MSG = "Diese Option kann im Bearbeitungsmodus nicht geändert werden.";
export class PromoCodeDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // form fields go here, e.g.:
            code: '',
            discount: '',
            validUntil: null,
            editMode: props.editMode || false,
            newNotCombinable: null,
            notCombinable: false, // example boolean field
            selectedPromoCodeCombinationRestrictions: ["Test"], // example array field
            yesNoDialogConfig: {
                open: false,
                title: "",
                content: "",
                onClose: null,
            },
            codeValidated: false,
            discountType: DISCOUNT_TYPES.FIX,
            checkboxValue: false,
            notCombinable: false,
            newNotCombinable: null, // for edit mode, to be able to switch back to original state if user toggles and then decides to restore
            selectedShopIds: [{ id: this.props.shopId },], // based on the selection for shop this will be set or the company id will be set.
            selectedCompanyId: 1, // if company wide code is selected then this will be set and shopIds will be null and vice versa
            allShopInfoList: [], // this will hold the shop infos of all shops related to the user for selection purposes in the shop selection dialog, it will be fetched on component mount based on the company id
            entitySelectionRequestData: {},
            entitySelectionDialogOpen: false,
            entitySelectionDialogTitle: "Test",
            entitySelectionDialogIcon: require("../../../../assets/icons/shopstore.png"),
            entitySelectionDialogEndpoint: "",
            entitySelectionDialogMethod: "POST",
            entitySelectionDialogIdField: "id",
            entitySelectionDialogAdditionalKeyFields: [], // in some cases, we need to put more than the id into the selected items on finishing the dialog (e.g. shopId)
            preSelectedEntities: [],
            description: { value: "", newValue: null },
            internalDescription: { value: "", newValue: null },
            validityDateStart: null,
            validityDateEnd: null,
            discountValue: "",
            minOrderValue: "",
            minOrderDeleted: false,
            maxDiscountValue: "",
            maxDiscountDeleted: false,
            selectedDeliveryType: { type: DELIVERY_CONFIG_TYPE.NO_RESTRICTION /*, newType: */ },
            timeConfig: [
                // { start: "10:00", end: "14:00", dow: "THU" },
                // { start: "09:30", end: "19:30", dow: "MON" }
            ],
            // postalCodeConfig: [{ zip: "28201" }, { zip: "28202" }, { zip: "28205" }, { zip: "28209" }, { zip: "28211" }, { zip: "28215" }, { zip: "28217" }, { zip: "28219" }, { zip: "28239" }, { zip: "28259" }, { zip: "28277" }, { zip: "28279" }, { zip: "28259" }, { zip: "28666" }],
            postalCodeConfig: [],
            selectedPaymentMethodOption: { selectionType: PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS },
            // selectedPaymentMethods: [{ type: PAYMENT_METHOD_TYPE.GIFTCARD }, { type: PAYMENT_METHOD_TYPE.ONLINE }, { type: PAYMENT_METHOD_TYPE.CASH }, { type: PAYMENT_METHOD_TYPE.CARD }],
            selectedPaymentMethods: [],
            categoryConfigOptions: { selectionType: CATEGORY_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS, scopeType: CATEGORY_SCOPE_TYPE.VALID_FOR }, // newSelectionType is set if we are in editMode and the user changes selection type (actually only no restrictions is possible since we can only expand the scope of allowed things in edit mode)
            // selectedCategories: [{ id: 1, name: "🍕 Pizza", shopId: 1 }, { id: 2, name: "🍔 Burger", shopId: 1 }, { id: 3, name: "🍔 Burger 2", shopId: 1 }, { id: 234, name: "🍕 Pizza", shopId: 2 }, { id: 235, name: "Test", shopId: 2 }, { id: 236, name: "Test2", shopId: 2 }],
            selectedCategories: [],
            shopSelectionType: { type: SHOP_SELECTION_TYPES.RESTRICTION_SHOP_WIDE /* newType */ },
            productConfigOptions: { selectionType: PRODUCT_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS, scopeType: PRODUCT_SCOPE_TYPE.VALID_FOR },
            // selectedProducts: [{ id: 1, name: "Pizza Margherita", shopId: 1 }, { id: 2, name: "Pizza Salami", shopId: 1 }, { id: 3, name: "Burger Classic", shopId: 1 }, { id: 4, name: "Burger Cheese", shopId: 1 }, { id: 5, name: "Burger Vegan", shopId: 1 }, { id: 6, name: "Sushi Set", shopId: 2 }, { id: 7, name: "Ramen Bowl", shopId: 2 }],
            selectedProducts: [],
            // selectedPromoCodeCombinationRestrictions: [{ id: 1, code: "SUMMER21", shopIds: [1, 2], deleted: false }, { id: 2, code: "WINTER21", shopIds: [2], deleted: false }],
            selectedPromoCodeCombinationRestrictions: [],
            // editMode: this.props.promoCodeEditModeData != null || this.props.editMode, // TODO CRM: Just for testing we check the editMode. Remove the || props.editMode afterwards.
            editMode: this.props.promoCodeEditModeData != null, // TODO CRM: Just for testing we check the editMode. Remove the || props.editMode afterwards.
            // editMode: false,
            perUserLimit: null,
            perUserLimitDeleted: false,
            globalCapQty: null,
            globalCapQtyDeleted: false,
            perShopLimit: null,
            perShopLimitDeleted: false,
            perShopUserLimit: null,
            perShopUserLimitDeleted: false,
            onEntitySelectionFinished: (selectedItems) => {
                console.log("Selected shops: ", selectedItems);
            },
            renderChipContent: (item) => (
                <div style={{ flex: 1 }}>
                    <span
                        style={{
                            fontSize: 16,
                            color: "#353535",
                        }}
                    >
                        <span style={{ fontWeight: "600" }}>Kategorie:</span> {item.name}{"  "}
                        <span style={{ fontWeight: "600" }}>(ID:</span> {item.id})
                    </span>

                    <span
                        style={{
                            fontSize: 16,
                            color: "#676767",
                        }}
                    >
                        {item.addressLine}
                    </span>
                </div>
            )
        }
        this.discountTypeOptions = [{ key: DISCOUNT_TYPES.FIX, label: "Fix-Preis" }, { key: DISCOUNT_TYPES.PERCENTAGE, label: "Prozentual" }]
    }
    stateValueSetter(key, value) {
        this.setState({ [key]: value })
    }
    filterEntitySelectionResults(result) {
        const { editMode } = this.state;
        if (!editMode) {
            return result.map(item => {
                const { added, ...rest } = item;
                return rest;
            }).filter(item => item.deselected !== true); // also remove deselected ones in creation mode, since they are not relevant at all
        }
        return result;
    }
    async loadShopInfos() {
        // const result = await apiHelper.getShopInfoByIdList(null, this.props.companyId);
        const result = await getShopInfoByIdList(null, this.props.companyId);
        this.setState({ allShopInfoList: result });
        // update selectedCategories with shopInfos:
        let myCategorySelections = this.state.selectedCategories.map((cat) => {
            const shopInfo = result.find((shop) => shop.id === cat.shopId);
            return { ...cat, shopInfo };
        });
        console.log("Updated category selections with shop infos: ", myCategorySelections);
        let myProductSelections = this.state.selectedProducts.map((prod) => {
            const shopInfo = result.find((shop) => shop.id === prod.shopId);
            return { ...prod, shopInfo };
        })

        let myPromoCodeCombinationRestrictions = this.state.selectedPromoCodeCombinationRestrictions.map((code) => {
            const shopInfo = result.find((shop) => shop.id === code.shopId);
            return { ...code, shopInfo };
        })
        this.setState({ selectedCategories: myCategorySelections, selectedProducts: myProductSelections, selectedPromoCodeCombinationRestrictions: myPromoCodeCombinationRestrictions });
        console.log("Shop Infos: ", result);
        return result;
    }
    async componentDidMount() {
        const allShopInfo = await this.loadShopInfos();
        if (this.props.promoCodeEditModeData) {
            // if we are in edit mode and have pre selected data then we will apply
            this.applyEditModeData(this.props.promoCodeEditModeData, allShopInfo);
            // TODO MAYBE WE MIGHT ADD A LOADING STATE AND LOAD THE DATA FROM HERE RIGHT AWAY OR DO THAT IN 
            // IN THE PARENT WE WILL SEE...
        }
    }
    applyEditModeData(promo, shopInfos) {
        if (!promo) return;
        console.log("######PROMO: ", promo)
        // ---- scope: company-wide vs shop-scoped ----
        const companyRow = Array.isArray(promo.shopConfig)
            ? promo.shopConfig.find(r => r.companyId != null && r.shopId == null)
            : null;

        console.log("Company row for promo: ", companyRow);
        const selectedCompanyId = companyRow ? Number(companyRow.companyId) : null;
        console.log("Selected company ID: ", selectedCompanyId);
        // for UI: selectedShopIds is an array of {id,...} items
        const selectedShopIds = !selectedCompanyId
            ? (Array.isArray(promo.shopConfig) ? promo.shopConfig
                .filter(r => r.shopId != null)
                .map(r => {
                    let shopInfo = shopInfos.find(s => Number(s.id) === Number(r.shopId));
                    return { id: Number(r.shopId), shopInfo };
                }) : [])
            : []; // company-wide => shops not selectable (or keep empty)
        console.log("Selected shop IDs for promo: ", selectedShopIds);
        // ---- dates ----
        const validityDateStart = promo.validFrom ? new Date(promo.validFrom) : null;
        const validityDateEnd = promo.validUntil ? new Date(promo.validUntil) : null;

        // ---- discount ----
        const hasPercent = promo.percent != null;
        const discountType = hasPercent ? DISCOUNT_TYPES.PERCENTAGE : DISCOUNT_TYPES.FIX;
        const discountValue = hasPercent ? String(promo.percent ?? '') : String(promo.fixed ?? '');

        // ---- descriptions / numeric strings ----
        const minOrderValue = promo.minOrderAmount != null ? String(promo.minOrderAmount) : '';
        const maxDiscountValue = promo.maxDiscount != null ? String(promo.maxDiscount) : ''; // if you use maxDiscountValue as maxDiscount; rename later if needed

        // ---- delivery restriction ----
        // adapt if your DeliveryConfigSection expects other shape
        let selectedDeliveryType = { type: DELIVERY_CONFIG_TYPE.NO_RESTRICTION };
        if (Number(promo.isPickupOnly) === 1) selectedDeliveryType = { type: DELIVERY_CONFIG_TYPE.PICKUP_ONLY };
        if (Number(promo.isDeliveryOnly) === 1) selectedDeliveryType = { type: DELIVERY_CONFIG_TYPE.DELIVERY_ONLY };

        // ---- time config ----
        // backend gives {start:"18:00:00"} but your UI wants "18:00"
        const timeConfig = Array.isArray(promo.timeConfig)
            ? promo.timeConfig.map(t => ({
                dow: t.dow,
                start: String(t.start || '').slice(0, 5),
                end: String(t.end || '').slice(0, 5)
            }))
            : [];

        // ---- zips ----
        const postalCodeConfig = Array.isArray(promo.zipConfig)
            ? promo.zipConfig
                .filter(z => String(z).trim().length > 0)
                .map(z => ({ zip: String(z) }))
            : [];

        // ---- payment methods ----
        // your example shows ["", "Online"] and also "Bar" in other example
        // filter empty strings and map to your PAYMENT_METHOD_TYPE
        const cleanedPayments = Array.isArray(promo.excludedPayments)
            ? promo.excludedPayments.map(x => String(x || '').trim()).filter(Boolean)
            : [];

        const mapPaymentToType = (p) => {
            // adjust mapping to your enum names
            // backend might be: Cash / Online / Card / Giftcard OR older: Bar / Geschenkkarte
            const v = p.toLowerCase();
            if (v === 'cash' || v === 'bar') return PAYMENT_METHOD_TYPE.CASH;
            if (v === 'card') return PAYMENT_METHOD_TYPE.CARD;
            if (v === 'online') return PAYMENT_METHOD_TYPE.ONLINE;
            if (v === 'giftcard' || v === 'geschenkkarte') return PAYMENT_METHOD_TYPE.GIFTCARD;
            if (v === 'paypal') return PAYMENT_METHOD_TYPE.PAYPAL;
            return null;
        };
        console.log("Cleaned payments from promo: ", cleanedPayments);
        let selectedPaymentMethods = Object.values(PAYMENT_METHOD_TYPE).map(type => { return { type: type } })
        if (cleanedPayments.length > 0) {
            cleanedPayments.forEach(p => {
                const mapped = mapPaymentToType(p);
                let index = selectedPaymentMethods.findIndex(m => m.type === mapped);
                if (index >= 0) {
                    selectedPaymentMethods.splice(index, 1);
                }
            })
            console.log("Selected payment methods after mapping and filtering: ", selectedPaymentMethods);
        }
        const selectedPaymentMethodOption = { selectionType: cleanedPayments.length > 0 ? PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED : PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS };

        // ---- product/category targeting ----
        // promo.shopConfig rows may contain productConfig/categoryConfig per shop
        const allProductTargets = Array.isArray(promo.productConfigs) ? promo.productConfigs : [];
        const allCategoryTargets = Array.isArray(promo.categoryConfigs) ? promo.categoryConfigs : [];

        // Array.isArray(promo.productConfigs) && promo.productConfigs.forEach(row => {
        //     const sid = row.shopId != null ? Number(row.shopId) : null;
        // })
        // (promo.shopConfig || []).forEach(row => {
        //     const sid = row.shopId != null ? Number(row.shopId) : null;
        //     if (!sid) return;

        // if (Array.isArray(row.productConfig)) {
        //     row.productConfig.forEach(p => {
        //         allProductTargets.push({
        //             id: Number(p.productId),
        //             shopId: sid,
        //             name: p.name ?? '',
        //             include: Number(p.include),
        //             minQty: p.minQty == null ? null : Number(p.minQty),
        //             added: false
        //         });
        //     });
        // }

        // if (Array.isArray(row.categoryConfig)) {
        //     row.categoryConfig.forEach(c => {
        //         allCategoryTargets.push({
        //             id: Number(c.catId),
        //             shopId: sid,
        //             include: Number(c.include),
        //             minQty: c.minQty == null ? null : Number(c.minQty),
        //             added: false
        //         });
        //     });
        // }
        // });

        console.log("All product targets from shopConfig: ", allProductTargets);

        // Decide which config you are in (product vs category)
        const hasProductConfig = allProductTargets.length > 0;
        const hasCategoryConfig = allCategoryTargets.length > 0;
        // if we have no restrictions, we just h
        const shopSelectionType = promo.shopConfig?.some(r => r.shopId == null) ? { type: SHOP_SELECTION_TYPES.NO_RESTRICTIONS } : { type: SHOP_SELECTION_TYPES.RESTRICTION_SHOP_WIDE };
        // Your UI selections want {id,name,shopId,shopInfo,...}
        // Name will come from dialog selection typically; for preload we can keep name empty and fill later once you have shopInfos / product/category lists.
        const selectedProducts = hasProductConfig
            ? allProductTargets.map(p => {
                let shopInfo = shopInfos.find(s => Number(s.id) === Number(p.shopId));
                return { id: p.id, name: p.name ?? '', shopId: p.shopId, shopInfo, include: p.include, minQty: p.minQty }
            })
            : [];

        const selectedCategories = hasCategoryConfig
            ? allCategoryTargets.map(c => {
                let shopInfo = shopInfos.find(s => Number(s.id) === Number(c.shopId));
                return { id: c.id, name: c.name ?? '', shopId: c.shopId, shopInfo, include: c.include, minQty: c.minQty }
            })
            : [];

        // selectionType based on include/exclude mode
        // include=1 => ONLY_SELECTED, include=0 => EXCEPT_SELECTED (or whatever your UI uses)
        // const inferSelectionType = (targets, ONLY_SELECTED, EXCEPT_SELECTED) => {
        //     const first = targets.find(t => t.include === 0 || t.include === 1);
        //     if (!first) return CATEGORY_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS;
        //     return first.include === 1 ? ONLY_SELECTED : EXCEPT_SELECTED;
        // };

        // const productSelectionType = inferSelectionType(
        //     allProductTargets,
        //     PRODUCT_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED,
        //     PRODUCT_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS
        // );
        const productScopeType = allProductTargets?.length > 0 && allProductTargets[0].include == 0 ? PRODUCT_SCOPE_TYPE.NOT_VALID_FOR : PRODUCT_SCOPE_TYPE.VALID_FOR;
        // const categorySelectionType = inferSelectionType(
        //     allCategoryTargets,
        //     CATEGORY_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED,
        //     CATEGORY_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS
        // );
        const categoryScopeType = allCategoryTargets?.length > 0 && allCategoryTargets[0].include == 0 ? CATEGORY_SCOPE_TYPE.NOT_VALID_FOR : CATEGORY_SCOPE_TYPE.VALID_FOR;

        const productConfigOptions = hasProductConfig ? { selectionType: PRODUCT_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED, scopeType: productScopeType } : { selectionType: PRODUCT_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS, scopeType: PRODUCT_SCOPE_TYPE.VALID_FOR }
        const categoryConfigOptions = hasCategoryConfig ? { selectionType: CATEGORY_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED, scopeType: categoryScopeType } : { selectionType: CATEGORY_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS, scopeType: CATEGORY_SCOPE_TYPE.VALID_FOR };

        // ---- combine restrictions ----
        // For preload, you at least want ids. Code/shop labels can be fetched by endpoint if needed.
        const selectedPromoCodeCombinationRestrictions = Array.isArray(promo.combineRestrictedCodes)
            ? promo.combineRestrictedCodes
            : [];

        // perUserLimit , 
        // globalCapQty , 
        // perShopLimit , This is not present...
        // perShopUserLimit, This isn also not present...
        console.log("PRODUCTCONFIGOPTIONS: ", productConfigOptions, " selectedProducts: ", selectedProducts, " promo: ", promo.perShopUserLimit);
        // ---- finally set state ----
        this.setState({
            code: promo.code ?? '',
            notCombinable: Number(promo.notCombinable) === 1,
            newNotCombinable: null, // reset any toggle override when loading edit data
            discountType,
            discountValue,
            validityDateStart,
            validityDateEnd,
            description: { value: promo.publicDescription ?? '', newValue: null },
            internalDescription: { value: promo.internalDescription ?? '', newValue: null },
            minOrderValue,
            maxDiscountValue,
            selectedDeliveryType,
            selectedCompanyId,
            selectedShopIds,
            timeConfig,
            postalCodeConfig,
            selectedPaymentMethodOption,
            selectedPaymentMethods,
            perUserLimit: promo.perUserLimit != null ? String(promo.perUserLimit) : null,
            globalCapQty: promo.globalCapQty != null ? String(promo.globalCapQty) : null,
            perShopLimit: promo.perShopLimit != null ? String(promo.perShopLimit) : null,
            perShopUserLimit: promo.perShopUserLimit != null ? String(promo.perShopUserLimit) : null,
            productConfigOptions,
            categoryConfigOptions,
            selectedProducts,
            selectedCategories,
            shopSelectionType,
            selectedPromoCodeCombinationRestrictions,

            editMode: true
        });
    }
    async onEditSave() {

        const { showAlert } = this.props;
        let body = {
            id: this.props.promoCodeEditModeData.id,
            ...(this.state.description.newValue !== null ? { publicDescription: this.state.description.newValue } : {}),
            ...(this.state.internalDescription.newValue !== null ? { internalDescription: this.state.internalDescription.newValue } : {}),
            ...(this.state.selectedDeliveryType.newType !== undefined ? { deliveryRestriction: this.state.selectedDeliveryType.newType } : {}),
            ...(this.state.shopSelectionType.newType !== undefined ? { shopSelectionType: this.state.shopSelectionType.newType } : {}),
        };

        console.log("Initial body for edit: ", body);
        if (this.state.shopSelectionType.newType !== SHOP_SELECTION_TYPES.NO_RESTRICTIONS) {
            const addedShopIds = this.state.selectedShopIds
                .filter(s => s.added === true)
                .map(s => s.id);

            if (addedShopIds.length > 0) {
                body.shopConfig = { added: addedShopIds };
            }
        }

        const timeConfig = this.state.timeConfig.filter(t => t.added === true);
        if (timeConfig.length > 0) {
            body.timeConfig = timeConfig.map(t => ({
                dow: t.dow,
                start: t.start,
                end: t.end
            }));
        }

        const postalCodeConfig = this.state.postalCodeConfig.filter(p => p.added === true);
        if (postalCodeConfig.length > 0) {
            body.postalCodeConfig = postalCodeConfig.map(p => p.zip);
        }
        console.log("Check1", body);
        /*
         PRODUCT CONFIG
        */

        if (this.state.productConfigOptions.newSelectionType !== undefined) {
            body.productConfig = {
                selectionType: this.state.productConfigOptions.newSelectionType
            };
        }
        else if (this.state.productConfigOptions.scopeType === PRODUCT_SCOPE_TYPE.NOT_VALID_FOR) {

            const deletedProducts = this.state.selectedProducts.filter(p => p.deleted === true);

            if (deletedProducts.length > 0) {
                body.productConfig = {
                    deleted: deletedProducts.map(p => ({
                        productId: p.id,
                        shopId: p.shopId
                    }))
                };
            }

        } else {

            const hasExistingMinQty = this.state.selectedProducts.some(p => p.minQty != null);

            const addedProducts = this.state.selectedProducts.filter(p => p.added === true);

            if (hasExistingMinQty && addedProducts.some(p => p.minQty == null)) {
                // TODO show validation message in UI
                showAlert("Bitte geben Sie für alle hinzugefügten Produkte eine Mindestmenge an, da bereits Produkte mit Mindestmenge in der Konfiguration vorhanden sind.", ALERT_SEVERITY.ERROR);
                return;
            }

            if (addedProducts.length > 0) {
                body.productConfig = {
                    ...body.productConfig,
                    added: addedProducts.map(p => ({
                        productId: p.id,
                        shopId: p.shopId,
                        ...(p.minQty ? { minQty: Number(p.minQty) } : {})
                    }))
                };
            }
        }
        console.log("Check2", body);
        /*
         CATEGORY CONFIG
        */

        if (this.state.categoryConfigOptions.newSelectionType !== undefined) {

            body.categoryConfig = {
                selectionType: this.state.categoryConfigOptions.newSelectionType
            };

        } else if (this.state.categoryConfigOptions.scopeType === CATEGORY_SCOPE_TYPE.NOT_VALID_FOR) {

            const deletedCategories = this.state.selectedCategories.filter(c => c.deleted === true);

            if (deletedCategories.length > 0) {
                body.categoryConfig = {
                    deleted: deletedCategories.map(c => ({
                        catId: c.id,
                        shopId: c.shopId
                    }))
                };
            }

        } else {

            const hasExistingMinQty = this.state.selectedCategories.some(c => c.minQty != null);
            const addedCategories = this.state.selectedCategories.filter(c => c.added === true);

            if (hasExistingMinQty && addedCategories.some(c => c.minQty == null)) {
                // TODO show validation message
                showAlert("Bitte geben Sie für alle hinzugefügten Kategorien eine Mindestmenge an, da bereits Kategorien mit Mindestmenge in der Konfiguration vorhanden sind.", ALERT_SEVERITY.ERROR);
                return;
            }

            if (addedCategories.length > 0) {

                body.categoryConfig = {
                    ...body.categoryConfig,
                    added: addedCategories.map(c => ({
                        catId: c.id,
                        shopId: c.shopId,
                        ...(c.minQty ? { minQty: Number(c.minQty) } : {})
                    }))
                };

            }
        }
        console.log("Check3", body);
        /*
         PAYMENT METHOD CONFIG
        */

        if (this.state.selectedPaymentMethodOption.newSelectionType !== undefined) {

            body.paymentMethodRestriction = {
                selectionType: this.state.selectedPaymentMethodOption.newSelectionType
            };

        } else if (
            this.state.selectedPaymentMethodOption.selectionType ===
            PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED
        ) {

            const addedPaymentMethods = this.state.selectedPaymentMethods
                .filter(m => m.added === true);

            if (addedPaymentMethods.length > 0) {
                body.paymentMethodRestriction = {
                    added: addedPaymentMethods.map(m => m.type)
                };
            }
        }
        console.log("Check4", body);
        /*
         PROMO COMBINATION RESTRICTIONS
        */

        const deletedPromoRestrictions =
            this.state.selectedPromoCodeCombinationRestrictions
                .filter(r => r.deleted === true);

        if (deletedPromoRestrictions.length > 0) {
            body.combineRestriction = {
                deleted: deletedPromoRestrictions.map(r => r.id)
            };
        }
        console.log("Check5", body);
        /*
         LIMIT FLAGS
        */

        if (this.state.maxDiscountDeleted) body.maxDiscount = 0;
        if (this.state.minOrderDeleted) body.minOrderAmount = 0;
        if (this.state.perShopLimitDeleted) body.perShopLimit = 0;
        if (this.state.globalCapQtyDeleted) body.globalCapQty = 0;
        if (this.state.perUserLimitDeleted) body.perUserLimit = 0;
        if (this.state.perShopUserLimitDeleted) body.perShopUserLimit = 0;

        /*
         CHECK IF ANYTHING CHANGED
        */
        console.log("CheckLAST", body);
        if (Object.keys(body).length === 1 && body.id) {
            showAlert("Daten sind bereits auf dem neuesten Stand.", ALERT_SEVERITY.INFO);
            return;
        }

        console.log("Body to send for edit:", body);

        // TODO HANDLE LOADING, SUCCESS, FAIL.

        const res = await editPromoCode(body);
        if (!res) {
            return showAlert("Fehler bei der Bearbeitung des Aktionscodes. Bitte versuche es später erneut.", ALERT_SEVERITY.ERROR);
        } else {
            showAlert("Aktionscode erfolgreich bearbeitet!", ALERT_SEVERITY.SUCCESS);
            this.props.onClose?.();
        }
    }
    async onCreateSave() {

        let body = {};

        body.code = this.state.code;
        body.publicDescription = this.state.description.value;

        if (this.state.internalDescription.value.trim().length > 0) {
            body.internalDescription = this.state.internalDescription.value;
        }

        if (this.state.notCombinable) {
            body.notCombinable = true;
        }

        if (this.state.validityDateStart != null) {
            body.validFrom = this.state.validityDateStart.toISOString();
        }

        if (this.state.validityDateEnd != null) {
            body.validUntil = this.state.validityDateEnd.toISOString();
        }

        if (this.state.discountType === DISCOUNT_TYPES.FIX) {
            body.fixed = Number(this.state.discountValue.replace(",", "."));
        } else {
            body.percent = Number(this.state.discountValue.replace(",", "."));
        }

        if (this.state.minOrderValue.trim().length > 0) {
            body.minOrderAmount = Number(this.state.minOrderValue.replace(",", "."));
        }

        if (this.state.maxDiscountValue.trim().length > 0) {
            body.maxDiscount = Number(this.state.maxDiscountValue.replace(",", "."));
        }

        if (this.state.selectedDeliveryType.type !== DELIVERY_CONFIG_TYPE.NO_RESTRICTION) {

            if (this.state.selectedDeliveryType.type === DELIVERY_CONFIG_TYPE.PICKUP_ONLY) {
                body.isPickupOnly = 1;
            } else {
                body.isDeliveryOnly = 1;
            }

        }

        if (this.state.selectedCompanyId != null) {

            body.shopConfig = [
                { companyId: this.state.selectedCompanyId, shopId: null }
            ];

        } else {

            body.shopConfig =
                this.state.selectedShopIds.map(s => ({
                    shopId: s.id,
                    companyId: this.props.companyId
                }));

        }

        if (this.state.perUserLimit != null && Number(this.state.perUserLimit) > 0)
            body.perUserLimit = Number(this.state.perUserLimit);

        if (this.state.perShopUserLimit != null && Number(this.state.perShopUserLimit) > 0)
            body.perShopUserLimit = Number(this.state.perShopUserLimit);

        if (this.state.globalCapQty != null && Number(this.state.globalCapQty) > 0)
            body.globalCapQty = Number(this.state.globalCapQty);

        if (this.state.perShopLimit != null && Number(this.state.perShopLimit) > 0)
            body.perShopLimit = Number(this.state.perShopLimit);

        if (this.state.timeConfig.length > 0) {
            body.timeConfig =
                this.state.timeConfig.map(t => ({
                    dow: t.dow,
                    start: t.start,
                    end: t.end
                }));
        }

        /*
         PRODUCT CONFIG
        */

        if (this.state.selectedProducts.length > 0) {

            if (this.state.productConfigOptions.selectionType === PRODUCT_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED) {

                let isInclude =
                    this.state.productConfigOptions.scopeType === PRODUCT_SCOPE_TYPE.VALID_FOR ? 1 : 0;

                body.productConfigs =
                    this.state.selectedProducts.map(p => ({
                        productId: p.id,
                        shopId: p.shopId,
                        minQty: isInclude ? Number(p.minQty) : null,
                        include: isInclude
                    }));

            }

        } else if (
            this.state.productConfigOptions.selectionType === PRODUCT_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED
        ) {

            // TODO validation message
            return;

        }

        /*
         CATEGORY CONFIG
        */

        if (
            this.state.selectedCategories.length > 0 &&
            this.state.productConfigOptions.selectionType !== PRODUCT_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED
        ) {

            if (this.state.categoryConfigOptions.selectionType === CATEGORY_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED) {

                let isInclude =
                    this.state.categoryConfigOptions.scopeType === CATEGORY_SCOPE_TYPE.VALID_FOR ? 1 : 0;

                body.categoryConfigs =
                    this.state.selectedCategories.map(c => ({
                        catId: c.id,
                        shopId: c.shopId,
                        minQty: isInclude ? Number(c.minQty) : null,
                        include: isInclude
                    }));

            }

        } else if (
            this.state.categoryConfigOptions.selectionType === CATEGORY_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED
        ) {

            // TODO validation message
            return;

        }

        /*
         PAYMENT METHODS
        */

        if (
            this.state.selectedPaymentMethodOption.selectionType ===
            PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED
        ) {

            if (this.state.selectedPaymentMethods.length > 0) {

                let allPaymentTypes =
                    Object.keys(PAYMENT_METHOD_TYPE)
                        .map(k => PAYMENT_METHOD_TYPE[k]);

                body.excludedPayments =
                    allPaymentTypes.filter(type =>
                        !this.state.selectedPaymentMethods
                            .some(m => m.type === type)
                    );

            } else {
                // TODO validation message
                return;
            }
        }

        /*
         PROMO COMBINATION
        */

        if (this.state.selectedPromoCodeCombinationRestrictions?.length > 0) {
            body.combineRestrictedIds =
                this.state.selectedPromoCodeCombinationRestrictions.map(r => r.id);
        }

        if (this.state.postalCodeConfig.length > 0) {
            body.zipConfig =
                this.state.postalCodeConfig.map(p => p.zip);
        }

        /*
         FINAL VALIDATION
        */
        const { showAlert } = this.props;
        console.log("Validating body before creation: ", body);
        console.log("Code validated state: ", this.state.codeValidated);
        console.log("Code state: ", this.state.code);
        if (body.code?.trim().length < 5 || !this.state.codeValidated) {
            showAlert("Der Aktionscode muss mindestens 5 Zeichen lang sein und darf nur Großbuchstaben enthalten. Außerdem muss der Code verfügbar sein.", ALERT_SEVERITY.ERROR);
            // TODO show validation error
            return;
        }

        if (body.fixed == 0 || body.percent == 0) {
            showAlert("Rabattbetrag muss einen gültigen Wert haben.", ALERT_SEVERITY.ERROR);
            return;
        }

        if (body.publicDescription?.length < 3) {
            showAlert("Die öffentliche Beschreibung muss mindestens 3 Zeichen lang sein.", ALERT_SEVERITY.ERROR);
            return;
        }

        console.log("Body to send for create:", body);


        // TODO HANDLE LOADING, SUCCESS, FAIL.

        const res = await createPromoCode(body);
        if (!res) {
            return showAlert("Fehler bei der Erstellung des Aktionscodes. Bitte versuche es später erneut.", ALERT_SEVERITY.ERROR);
        } else {
            showAlert("Aktionscode erfolgreich erstellt!", ALERT_SEVERITY.SUCCESS);
            this.props.onClose?.();
        }
    }
    render() {
        const { shopId, companyId, platformMode, ...rest } = this.props;
        const { showAlert } = this.props; // we do that extra extraction here to be able to use showAlert in the DialogWrapper 
        const currentNotCombinable = this.state.newNotCombinable !== null ? this.state.newNotCombinable : this.state.notCombinable;
        return (
            <>
                <DialogWrapper
                    fixedHeight="90vh"
                    actions={
                        <>
                            <Button onClick={() => this.props.onClose?.()} color="error">
                                Schließen
                            </Button>
                            <Button onClick={() => {
                                if (this.state.editMode) {
                                    this.onEditSave();
                                } else {
                                    this.onCreateSave();
                                }
                            }} color="primary" variant="contained">
                                Speichern
                            </Button>
                        </>
                    }
                    {...rest}>
                    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                        {/* Dialog content goes here */}
                        <ValidatedTextInput
                            placeholder="Code"
                            preFilledValue={this.state.editMode ? this.state.code : undefined}
                            value={this.state.code}
                            minLength={5}
                            maxLength={20}
                            onChangeText={(txt) => { this.setState({ code: txt.toUpperCase() }) }}
                            checkFunction={async (txt) => {
                                const res = await checkCodeAvailabilityForCreation({ code: txt, ...(this.state.shopSelectionType.type === SHOP_SELECTION_TYPES.NO_RESTRICTIONS ? { companyId: this.props.companyId } : { shopIds: this.state.selectedShopIds.map(s => s.id) }) });
                                console.log("Code availability result: ", res);
                                this.setState({ codeValidated: res });
                                return res;
                                // const res = await 
                                // just for testing
                                // if (txt.length > 6) {
                                //     return true;
                                // }
                                // return false;
                            }}
                            onFocus={() => {
                                // alert("Fokus auf Code Input");
                                console.log("Fokus auf Code Input");
                                if (this.state.editMode) {
                                    showAlert("Code kann im Bearbeitungsmodus nicht geändert werden.", ALERT_SEVERITY.WARNING);
                                }
                            }}
                            disabled={this.state.editMode}
                        />
                        <div style={{ marginLeft: -8 }}> {/* to align the switch a bit better with the text input above */}
                            <LabeledSwitch label="Nicht kombinierbar" value={currentNotCombinable} onChange={(e) => {
                                const { editMode, notCombinable } = this.state;
                                const { checked: switchValue } = e.target;
                                // this.setState({ notCombinable: switchValue })
                                if (!editMode) {
                                    if (this.state.selectedPromoCodeCombinationRestrictions?.length > 0 && switchValue) {
                                        return this.setState({
                                            yesNoDialogConfig: {
                                                open: true,
                                                title: "Einschränkungen entfernen?",
                                                content: "Es sind bereits Einschränkungen für die Kombination mit anderen Aktionscodes gesetzt. Möchtest du diese entfernen, um den Aktionscode nicht kombinierbar zu machen?",
                                                onClose: (confirmed) => {
                                                    console.log("YN Dialog Result:", confirmed);
                                                    if (confirmed) {
                                                        this.setState({
                                                            notCombinable: switchValue,
                                                            selectedPromoCodeCombinationRestrictions: [],
                                                            newNotCombinable: null,
                                                            yesNoDialogConfig: {
                                                                open: false,
                                                                title: "",
                                                                content: "",
                                                                onClose: null,
                                                            }
                                                        });
                                                    } else {
                                                        this.setState({
                                                            // just close the dialog without changing the switch value
                                                            yesNoDialogConfig: {
                                                                open: false,
                                                                title: "",
                                                                content: "",
                                                                onClose: null,
                                                            }
                                                        });
                                                    }
                                                }
                                            }
                                        })
                                    }
                                    return this.setState({
                                        notCombinable: switchValue,
                                        newNotCombinable: null, // optional but recommended
                                    });
                                }

                                if (notCombinable !== true) {
                                    showAlert(DEFAULT_NOT_EDITABLE_MSG, ALERT_SEVERITY.WARNING);
                                    return;
                                }
                                if (switchValue === true) {
                                    this.setState({ newNotCombinable: null });
                                } else {
                                    this.setState({ newNotCombinable: false });
                                }
                            }} />
                        </div>
                        <ValidTimeRangeSection startDate={this.state.validityDateStart} setStartDate={(date) => this.setState({ validityDateStart: date })} endDate={this.state.validityDateEnd} setEndDate={(date) => this.setState({ validityDateEnd: date })} editMode={this.state.editMode} noDelete={this.state.editMode} />
                        <DiscountConfigSection discountTypeOptions={this.discountTypeOptions} discountType={this.state.discountType} discountValue={this.state.discountValue} minOrderValue={this.state.minOrderValue} minOrderDeleted={this.state.minOrderDeleted} maxDiscountDeleted={this.state.maxDiscountDeleted} maxDiscountValue={this.state.maxDiscountValue} setValue={(k, v) => this.stateValueSetter(k, v)} description={this.state.description} internalDescription={this.state.internalDescription} editMode={this.state.editMode} showAlert={showAlert} />
                        <DeliveryConfigSection selectedDeliveryType={this.state.selectedDeliveryType}
                            onDeliveryTypeChange={(type) => {
                                console.log("Selected delivery type: ", type);
                                if (type.type === DELIVERY_CONFIG_TYPE.PICKUP_ONLY && this.state.postalCodeConfig?.length > 0) {
                                    this.setState({
                                        yesNoDialogConfig: {
                                            open: true,
                                            title: "Postleitzahlen entfernen?",
                                            content: "Wenn du Abholung auswählst, werden alle vorhandenen Ortseinschränkungen (Postleitzahlen) entfernt. Möchtest du fortfahren?",
                                            onClose: (confirmed) => {
                                                console.log("YN Dialog Result:", confirmed);
                                                if (confirmed) {
                                                    this.setState({
                                                        selectedDeliveryType: type,
                                                        postalCodeConfig: [],
                                                        yesNoDialogConfig: {
                                                            open: false,
                                                            title: "",
                                                            content: "",
                                                            onClose: null,
                                                        }
                                                    });
                                                } else {
                                                    this.setState({
                                                        yesNoDialogConfig: {
                                                            open: false,
                                                            title: "",
                                                            content: "",
                                                            onClose: null,
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    })

                                } else {
                                    this.setState({ selectedDeliveryType: type })
                                }
                            }} editMode={this.state.editMode} />
                        <CapConfigSection perUserLimit={this.state.perUserLimit} perUserLimitDeleted={this.state.perUserLimitDeleted}
                            globalCapQtyDeleted={this.state.globalCapQtyDeleted} perShopLimitDeleted={this.state.perShopLimitDeleted} perShopUserLimitDeleted={this.state.perShopUserLimitDeleted}
                            globalCapQty={this.state.globalCapQty}
                            perShopLimit={this.state.perShopLimit}
                            perShopUserLimit={this.state.perShopUserLimit} setValue={(k, v) => this.stateValueSetter(k, v)} editMode={this.state.editMode} showAlert={showAlert} />
                        <ShopSelectionSection shopList={this.state.allShopInfoList} selectedShops={this.state.selectedShopIds} selectedCompanyId={this.state.selectedCompanyId}
                            selectionType={this.state.shopSelectionType}
                            setSelectionType={(type) => {
                                console.log("Selected shop selection type: ", type);
                                if (type === SHOP_SELECTION_TYPES.NO_RESTRICTIONS) {
                                    console.log("Setting state to: ", { selectedCompanyId: companyId, shopSelectionType: type });
                                    this.setState({ selectedCompanyId: companyId, shopSelectionType: type })
                                } else {
                                    console.log("Setting state to: ", { selectedCompanyId: null, shopSelectionType: type });
                                    this.setState({ selectedCompanyId: null, shopSelectionType: type })
                                }
                            }}
                            onShopSelectionChange={(selectedShops) => {
                                console.log("Selected shops: ", selectedShops);
                                if (selectedShops.length === 0) {

                                    showAlert("Es muss mindestens ein Shop ausgewählt werden.", ALERT_SEVERITY.WARNING);
                                    return;
                                }
                                this.setState({ selectedShopIds: selectedShops })
                            }}
                            onShopSelectionPressed={() => {
                                this.setState({
                                    entitySelectionDialogOpen: true,
                                    entitySelectionDialogIcon: require("../../../../assets/icons/store.png"),
                                    entitySelectionDialogTitle: "Shopauswahl",
                                    entitySelectionDialogMethod: "GET",
                                    entitySelectionDialogEndpoint: (page, ipp, search) => `${APIData.SHOP}/getShopsPaginated?page=${page}&ipp=${ipp}&companyId=${companyId}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}`,
                                    entitySelectionRequestData: undefined, // no body required for this request
                                    preSelectedEntities: this.state.selectedShopIds,
                                    entitySelectionDialogIdField: "id",
                                    additionalKeysToAdd: this.state.entitySelectionDialogAdditionalKeyFields,
                                    renderChipContent: (item) => (
                                        <div style={{ display: "flex", flexDirection: "column", flex: 1, gap: 5 }}>
                                            <span
                                                style={{
                                                    fontSize: 16,
                                                    color: "#353535",
                                                }}
                                            >
                                                <strong>Shop:</strong> {item.name}{"  "}
                                                <strong>(ID.:</strong> {item.id})
                                            </span>

                                            <span
                                                style={{
                                                    fontSize: 16,
                                                    color: "#676767",
                                                }}
                                            >
                                                Adresse: {item.street} {item.houseNumber}, {item.zip} {item.city}
                                            </span>
                                        </div>
                                    ),
                                    onEntitySelectionFinished: (selectedItems) => {
                                        const finalItems = this.filterEntitySelectionResults(selectedItems);
                                        if (finalItems?.length > 0) {
                                            this.setState({ selectedShopIds: finalItems });
                                            console.log("Selected shops: ", finalItems);
                                        } else {
                                            showAlert("Es muss mindestens ein Shop ausgewählt werden.", ALERT_SEVERITY.WARNING);
                                        }
                                        // todo
                                    }
                                })
                            }} editMode={this.state.editMode} showAlert={showAlert} />
                        <TimeConfigSection
                            config={this.state.timeConfig}
                            setConfig={(config) => this.setState({ timeConfig: config })}
                            editMode={this.state.editMode}
                            showAlert={this.props.showAlert}
                        />
                        <PostalCodeConfigSection config={this.state.postalCodeConfig} isPickupMode={this.state.selectedDeliveryType.type === DELIVERY_CONFIG_TYPE.PICKUP_ONLY} setConfig={(config) => { this.setState({ postalCodeConfig: config }) }} editMode={this.state.editMode} showAlert={showAlert} />
                        <ProductConfigSection showAlert={showAlert} selectedProducts={this.state.selectedProducts}
                            setSelectedProducts={(products) => this.setState({ selectedProducts: products })}
                            onSelectionPressed={() => {
                                console.log("Selected shops for product selection: ", this.state.selectedShopIds);
                                const shopIdList = this.state.selectedShopIds?.length > 0 ? this.state.selectedShopIds.map((s) => s.id) : null;
                                this.setState({
                                    entitySelectionDialogOpen: true,
                                    entitySelectionDialogIcon: require("../../../../assets/icons/dairyproducts.png"),
                                    entitySelectionDialogTitle: "Produkt Hinzufügen",
                                    entitySelectionDialogMethod: "POST",
                                    entitySelectionDialogEndpoint: (page, ipp, search) => `${APIData.SHOP}/multiShopProducts?page=${page}&ipp=${ipp}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}`,
                                    entitySelectionRequestData: { ...(shopIdList != null ? { shopIds: shopIdList } : { companyId: this.state.selectedCompanyId ?? companyId }) }, // no body required for this request
                                    preSelectedEntities: this.state.selectedProducts,
                                    entitySelectionDialogIdField: "id",
                                    entitySelectionDialogAdditionalKeyFields: ["shopId", "name"],
                                    renderChipContent: (item) => {
                                        const shopInfo = this.state.allShopInfoList.find((shop) => shop.id === item.shopId);

                                        return (
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: 14,
                                                        color: '#353535',
                                                        wordBreak: 'break-word',
                                                    }}
                                                >
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                        Produkt:
                                                    </Box>{' '}
                                                    {item.name}{' '}
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                        (ID:
                                                    </Box>{' '}
                                                    {item.id})
                                                </Typography>

                                                {shopInfo && (
                                                    <Typography
                                                        sx={{
                                                            fontSize: 13,
                                                            color: '#676767',
                                                            wordBreak: 'break-word',
                                                        }}
                                                    >
                                                        Shop: {shopInfo.name} (ID: {shopInfo.id})
                                                    </Typography>
                                                )}
                                            </Box>
                                        );
                                    },
                                    onEntitySelectionFinished: (selectedItems) => {
                                        console.log("SElecdtedITems: ", selectedItems);
                                        let finalItems = this.filterEntitySelectionResults(selectedItems);
                                        finalItems = finalItems.map((cat) => {
                                            const shopInfo = this.state.allShopInfoList.find((shop) => shop.id === cat.shopId);
                                            return { ...cat, shopInfo };
                                        });
                                        console.log("Final items after filtering and adding shop info: ", finalItems);
                                        this.setState({ selectedProducts: finalItems });
                                        console.log("Selected products: ", finalItems);
                                    }
                                })
                            }}
                            selectedOptions={this.state.productConfigOptions} setSelectedOptions={(options) => {
                                // check if category has been specified already and avoid switch
                                console.log("Selected product config options: ", options);
                                console.log("Current category config options: ", this.state.categoryConfigOptions);
                                if (options.selectionType === PRODUCT_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED && this.state.categoryConfigOptions.selectionType === CATEGORY_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED) {
                                    //     return Alert.alert(LABEL[langCode]?.WarningWithEmoji, LABEL[langCode]?.ProductOrCategoryRulesOnly);
                                    return showAlert("Es können nur Produkt- oder Kategorieregeln für einen Aktionscode konfiguriert werden.", ALERT_SEVERITY.WARNING);
                                }
                                this.setState({ productConfigOptions: options })
                            }} editMode={this.state.editMode} />
                        <CategoryConfigSection showAlert={showAlert} selectedCategories={this.state.selectedCategories}
                            setSelectedCategories={(categories) => this.setState({ selectedCategories: categories })}
                            onCategorySelectionPressed={() => {
                                const shopIdList = this.state.selectedShopIds?.length > 0 ? this.state.selectedShopIds.map((s) => s.id) : null;
                                this.setState({
                                    entitySelectionDialogOpen: true,
                                    entitySelectionDialogIcon: require("../../../../assets/icons/categories.png"),
                                    entitySelectionDialogTitle: "Kategorie Hinzufügen",
                                    entitySelectionDialogMethod: "POST",
                                    entitySelectionDialogEndpoint: (page, ipp, search) => `${APIData.SHOP}/multiShopCategories?page=${page}&ipp=${ipp}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}`,
                                    entitySelectionRequestData: { ...(shopIdList != null ? { shopIds: shopIdList } : { companyId: this.state.selectedCompanyId ?? companyId }) }, // no body required for this request
                                    preSelectedEntities: this.state.selectedCategories,
                                    entitySelectionDialogIdField: "id",
                                    entitySelectionDialogAdditionalKeyFields: ["shopId", "name"],
                                    renderChipContent: (item) => {
                                        const shopInfo = this.state.allShopInfoList.find((shop) => shop.id === item.shopId);
                                        return (
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: 14,
                                                        color: '#353535',
                                                        wordBreak: 'break-word',
                                                    }}
                                                >
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                        Kategorie:
                                                    </Box>{' '}
                                                    {item.name}{' '}
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                        (ID:
                                                    </Box>{' '}
                                                    {item.id})
                                                </Typography>

                                                {shopInfo && (
                                                    <Typography
                                                        sx={{
                                                            fontSize: 13,
                                                            color: '#676767',
                                                            wordBreak: 'break-word',
                                                        }}
                                                    >
                                                        Shop: {shopInfo.name} (ID: {shopInfo.id})
                                                    </Typography>
                                                )}

                                                {item.minQty != null && (
                                                    <Typography
                                                        sx={{
                                                            fontSize: 13,
                                                            color: '#676767',
                                                        }}
                                                    >
                                                        Mindestmenge: {item.minQty}
                                                    </Typography>
                                                )}
                                            </Box>
                                        );
                                    },
                                    onEntitySelectionFinished: (selectedItems) => {
                                        console.log("SElecdtedITems: ", selectedItems);
                                        let finalItems = this.filterEntitySelectionResults(selectedItems);
                                        finalItems = finalItems.map((cat) => {
                                            const shopInfo = this.state.allShopInfoList.find((shop) => shop.id === cat.shopId);
                                            return { ...cat, shopInfo };
                                        });
                                        console.log("Final items after filtering and adding shop info: ", finalItems);
                                        this.setState({ selectedCategories: finalItems });
                                        console.log("Selected categories: ", finalItems);
                                    }
                                })
                            }}
                            selectedOptions={this.state.categoryConfigOptions} setSelectedOptions={(options) => {
                                if (options.selectionType === CATEGORY_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED && this.state.productConfigOptions.selectionType === PRODUCT_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED) {
                                    // return Alert.alert(LABEL[langCode]?.WarningWithEmoji, LABEL[langCode]?.ProductOrCategoryRulesOnly);
                                    return showAlert("Es können nur Produkt- oder Kategorieregeln für einen Aktionscode konfiguriert werden.", ALERT_SEVERITY.WARNING);
                                }
                                this.setState({ categoryConfigOptions: options })
                            }} editMode={this.state.editMode} />
                        <PaymentMethodConfigSection selectedPaymentMethods={this.state.selectedPaymentMethods} setSelectedPaymentMethods={(methods) => this.setState({ selectedPaymentMethods: methods })}
                            selectedOption={this.state.selectedPaymentMethodOption} setSelectedOption={(option) => this.setState({ selectedPaymentMethodOption: option })} editMode={this.state.editMode} showAlert={showAlert} />
                        <PromoCodeCombineRestrictionConfigSection
                            selectedCodes={this.state.selectedPromoCodeCombinationRestrictions}
                            setSelectedCodes={(codes) => this.setState({ selectedPromoCodeCombinationRestrictions: codes })}
                            onSelectionPressed={() => {
                                if (this.state.editMode) {
                                    // if the length is 0 we cant add. But if there are already some 
                                    // return Alert.alert(LABEL[langCode]?.WarningWithEmoji, LABEL[langCode]?.DataNotEditable);
                                    return showAlert(DEFAULT_NOT_EDITABLE_MSG, ALERT_SEVERITY.WARNING);
                                } else if (this.state.notCombinable || this.state.newNotCombinable /** newNotCombinable can't be true whilst !editMode actually but double checking is okay here. */) {
                                    // return Alert.alert(LABEL[langCode]?.WarningWithEmoji, LABEL[langCode]?.CannotAddCombinationRestrictionsWhenNotCombinable);
                                    return showAlert("Kombinationseinschränkungen können nicht hinzugefügt werden, wenn „Nicht kombinierbar“ aktiv ist.", ALERT_SEVERITY.WARNING)
                                }
                                console.log("Selected shops for product selection: ", this.state.selectedShopIds);
                                const shopIdList = this.state.selectedShopIds?.length > 0 ? this.state.selectedShopIds.map((s) => s.id) : null;
                                this.setState({
                                    entitySelectionDialogOpen: true,
                                    entitySelectionDialogIcon: require("../../../../assets/icons/voucher.png"),
                                    entitySelectionDialogTitle: "Promocode hinzufügen",
                                    entitySelectionDialogMethod: "POST",
                                    entitySelectionDialogEndpoint: (page, ipp, search) => `${APIData.SHOP}/multiShopPromocodes?page=${page}&ipp=${ipp}${search != null && search.length > 3 ? `&search=${encodeURIComponent(search)}` : ""}`,
                                    entitySelectionRequestData: { ...(shopIdList != null ? { shopIds: shopIdList } : { companyId: this.state.selectedCompanyId ?? companyId }) },
                                    preSelectedEntities: this.state.selectedPromoCodeCombinationRestrictions,
                                    entitySelectionDialogIdField: "id",
                                    entitySelectionDialogAdditionalKeyFields: ["shopId", "code"],
                                    renderChipContent: (item) => {
                                        const shopInfo = this.state.allShopInfoList.find((shop) => shop.id === item.shopId);

                                        return (
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    sx={{
                                                        fontSize: 14,
                                                        color: "#353535",
                                                        wordBreak: "break-word",
                                                    }}
                                                >
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                        Code:
                                                    </Box>{" "}
                                                    {item.code}{" "}
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                        (ID:
                                                    </Box>{" "}
                                                    {item.id})
                                                </Typography>

                                                {shopInfo && (
                                                    <Typography
                                                        sx={{
                                                            fontSize: 13,
                                                            color: "#676767",
                                                            wordBreak: "break-word",
                                                        }}
                                                    >
                                                        Shop: {shopInfo.name} (ID: {shopInfo.id})
                                                    </Typography>
                                                )}
                                            </Box>
                                        );
                                    },
                                    onEntitySelectionFinished: (selectedItems) => {
                                        console.log("SElecdtedITems: ", selectedItems);
                                        let finalItems = this.filterEntitySelectionResults(selectedItems);
                                        finalItems = finalItems.map((cat) => {
                                            const shopInfo = this.state.allShopInfoList.find((shop) => shop.id === cat.shopId);
                                            return { ...cat, shopInfo };
                                        });
                                        console.log("Final items after filtering and adding shop info: ", finalItems);
                                        // if (finalItems.length > 0) {
                                        this.setState({ selectedPromoCodeCombinationRestrictions: finalItems });
                                        console.log("Selected promo code combination restrictions: ", finalItems);
                                        // } else {
                                        //     Alert.alert(LABEL[langCode]?.WarningWithEmoji, LABEL[langCode]?.AtLeastOneShopRequired);
                                        // }
                                        // todo
                                    }
                                })
                            }}
                            editMode={this.state.editMode} showAlert={showAlert} />
                    </div>
                </DialogWrapper>
                <EntitySelectionDialog
                    showAlert={showAlert}
                    isOpen={this.state.entitySelectionDialogOpen}
                    title={this.state.entitySelectionDialogTitle}
                    icon={this.state.entitySelectionDialogIcon}
                    apiEndpoint={this.state.entitySelectionDialogEndpoint}
                    method={this.state.entitySelectionDialogMethod}
                    body={this.state.entitySelectionRequestData}
                    keyFieldName={this.state.entitySelectionDialogIdField}
                    multipleSelection={true}
                    deselectionDisabled={this.state.editMode}
                    data={this.state.preSelectedEntities}
                    searchPlaceholder={"Suche"}
                    additionalKeysToAdd={this.state.entitySelectionDialogAdditionalKeyFields}
                    // onEntitySelectionFinished={this.state.onEntitySelectionFinished}
                    onClose={() => this.setState({ entitySelectionDialogOpen: false, entitySelectionDialogEndpoint: "" })}
                    onFinish={(result) => {

                        /**
                         * All right we have two flags here:
                         * deselected: true => user has deselected the entity on the dialog
                         * this means, that we are most likely not in edit mode, so this is a creation
                         * and therefore we update the entity data with the result, just by removing the deselected entities from the result.
                         * 
                         * added: true and this means, that this data came from the dialog for newly selected ones:
                         * we can ignore that flag if we are at creation and put it in with the flag into our state for the entity
                         * and for edit mode we look for the added ones for update. Well it might confuse the EntitySelectionDialog.
                         * Not sure yet
                         * 
                         * 
                         * CONCLUSION: We filter for deselected ones and remove the added flag if we are in creation mode (editMode = false) and
                         * if we are in edit mode we keep the added flag and update our entity data...
                         */
                        this.setState({ entitySelectionDialogOpen: false });

                        if (result) {
                            // user pressed submit
                            console.log("Selected:", result);
                            this.state.onEntitySelectionFinished(result);
                            this.setState({
                                // selectedEntities: result,
                                entitySelectionDialogEndpoint: ""
                            });
                        }
                        // result === null → user cancelled
                    }}
                    renderChipContent={(item) => (
                        this.state.renderChipContent(item)
                    )}
                />
                <YesNoDialog open={this.state.yesNoDialogConfig.open} title={this.state.yesNoDialogConfig.title} label={this.state.yesNoDialogConfig.content} onClose={this.state.yesNoDialogConfig.onClose} />
            </>
        )
    }
}

export default PromoCodeDialog